
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tenantId: null,
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setTenant: (state, action) => {
      state.tenantId = action.payload;
    },
    setAccessToken: (state, action) => {
      state.token = action.payload;
    },
    resetTenant: (state) => {
      state.tenantId = null;
      state.token = null;
    },
  },
});

export const { setTenant, setAccessToken, resetTenant } = authSlice.actions;
export default authSlice.reducer;
